// #006a4e, #2e856e, #5ca08e, #8abaae, #b8d5

const theme = {
  id: "Green",
  name: "اخضر",
  header: {
    h1: {
      color: "#fff",
      fontSize: 32,
      fontFamily: "Rakkas-Regular",
      fontStyle: "normal",
    },
    h2: {
      color: "#8abaae",
      fontSize: 16,
      fontFamily: "Tajawal-Regular",
      fontStyle: "normal",
    },
    texture: "background-0",

    backgroundColor: "#2e856e",
  },
  note: {
    header: {
      texture: "background-0",

      backgroundColor: "#006a4e",
      text: {
        color: "#fff",
        fontSize: 16,
        fontFamily: "Tajawal-Regular",
        fontStyle: "normal",

        contents: "",
      },
    },
    body: {
      texture: "background-1",
      backgroundColor: "#8abaae",
      text: {
        color: "#000",
        fontSize: "24px",
        fontFamily: "Tajawal-Regular",
        fontStyle: "normal",

        contents: "",
      },
    },
  },
  main: {
    weekHeader: {
      texture: "background-0",

      backgroundColor: "#006a4e",
      text: {
        color: "#fff",
        fontSize: 16,
        fontFamily: "Tajawal-Regular",
        fontStyle: "normal",
        contents: "",
      },
    },
    blockActive: { backgroundColor: "#fffdf4", borderColor: "gray" },
    blockUnActive: { backgroundColor: "#2e856e" },
    withBorderDays: true,
  },
  images: {
    "image-top-right": {
      width: 64,
      height: 64,
      src: "",
      visible: false,
      blur: false,
      opacity: 1,
    },
    "image-center-right": {
      width: 64,
      height: 64,
      src: "",
      visible: false,
      blur: false,
      opacity: 1,
    },
    "image-center-left": {
      width: 64,
      height: 64,
      src: "",
      visible: false,
      blur: false,
      opacity: 1,
    },
    "image-top-left": {
      width: 64,
      height: 64,
      src: "",
      visible: false,
      blur: false,
      opacity: 1,
    },
    "image-bottom-right": {
      width: 64,
      height: 64,
      src: "",
      visible: false,
      blur: false,
      opacity: 1,
    },
  },
};
export default theme;
